import {UI} from "../../../../stem-core/ui/UIBase";
import {StyleSheet} from "../../../../stem-core/ui/Style";

import {styleRule} from "../../../../stem-core/decorators/Style";
import {registerStyle, Theme} from "../../../../stem-core/ui/style/Theme";
import {BlinkLightningIcon} from "../../../../core/ui/SVGElements.jsx";
import {WidgetRoutes} from "../../WidgetRoutes";
import {WALLET_COLLAPSED_WIDTH} from "../../WidgetConstants";
import {WidgetActiveRouteElement} from "../../ui/WidgetActiveRouteElement";
import {Router} from "../../../../stem-core/ui/Router";
import {UserPreferences} from "../../../State";
import {RollAnimatedBalance} from "../../../common/RollAnimatedBalance";


class IndexCollapsedStyle extends StyleSheet {
    @styleRule
    indexCollapsed = {
        background: this.themeProps.WALLET_13,
        position: "absolute",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        width: "100%",
        height: "100%",
        top: 0,
        left: 0,
        zIndex: 5,
        opacity: 1,
        transition: `${this.themeProps.DEFAULT_TRANSITION_DURATION_MS / 2}ms linear`,
        cursor: "pointer",
    };

    @styleRule
    whiteScreen = {
        background: () => this.themeProps.WHITE + " !important",
    };

    @styleRule
    invisible = {
        opacity: "0 !important",
    };

    @styleRule
    unclickable = {
        pointerEvents: "none",
    };

    @styleRule
    inlineBalance = {
        fontSize: 18,
        fontWeight: "initial",
        width: "58px !important",
        height: "1em",
        color: Theme.props.WALLET_BALANCE_COLOR,
        transform: "translateY(-3px) !important",
        marginLeft: 10,
    }
}

@registerStyle(IndexCollapsedStyle)
export class IndexCollapsed extends WidgetActiveRouteElement {
    expanded = false;
    static invisibleTimeout;
    static unclickableTimeout;

    extraNodeAttributes(attr) {
        super.extraNodeAttributes(attr);
        const {indexCollapsed, unclickable, invisible} = this.styleSheet;
        attr.addClass(indexCollapsed);
        attr.setAttribute("test-id", "widgetIndexCollapsed");
        if (this.expanded) {
            attr.addClass(unclickable);
            attr.addClass(invisible);
        }
    }

    render() {
        const balanceElement = UserPreferences.getPreferences()?.shouldShowBalanceInline() &&
            <RollAnimatedBalance className={this.styleSheet.inlineBalance}/>;

        return [
            <BlinkLightningIcon size={balanceElement ? 24 : 31} color="white"/>,
            balanceElement,
        ]
    }

    // TODO: Maybe the show and hide should be implemented on a redraw based logic.
    static hide() {
        const {instance} = this;
        if (instance.expanded) {
            return;
        }
        instance.expanded = true;
        const {invisible, unclickable, whiteScreen} = instance.styleSheet;
        instance.addClass(whiteScreen);
        this.invisibleTimeout = instance.attachTimeout(() => {
            if (instance.expanded) {
                instance.addClass(invisible);
                clearTimeout(this.invisibleTimeout);
            }
        }, instance.themeProps.DEFAULT_TRANSITION_DURATION_MS / 3.5);
        this.unclickableTimeout = instance.attachTimeout(() => {
            if (instance.expanded) {
                instance.addClass(unclickable);
                clearTimeout(this.invisibleTimeout);
            }
        }, instance.themeProps.DEFAULT_TRANSITION_DURATION_MS / 2);
    }

    static show() {
        const {instance} = this;
        instance.expanded = false;
        clearTimeout(this.invisibleTimeout);
        clearTimeout(this.unclickableTimeout);
        const {whiteScreen, invisible, unclickable} = instance.styleSheet;
        instance.removeClass(unclickable);
        instance.removeClass(invisible);
        instance.removeClass(whiteScreen);
        instance.dispatchHeightChange();
    }

    computeHeight() {
        return WALLET_COLLAPSED_WIDTH;
    }

    onMount() {
        super.onMount();
        this.addClickListener(() => Router.changeURL(WidgetRoutes.INDEX_EXPANDED));
        this.attachChangeListener(UserPreferences, () => this.redraw());
    }
}
